import type { GetReceiptBatchEntryResultLineItemTaxDto } from './ReceiptBatchControllerDefinition';
import { ReceiptBatchState } from './ReceiptBatchControllerDefinition';

interface ReceiptBatchEntry {
  amount?: number;
  receiptDate?: Date;
  residentId?: string;
  lineItems?: Array<{
    amountPerItemInCent: number;
    taxes?: GetReceiptBatchEntryResultLineItemTaxDto[];
    name: string | undefined;
  }>;
}

// eslint-disable-next-line complexity
export const isServiceProviderReceiptBatchReadyToSubmit = ({
  batch,
}: {
  batch:
    | {
        receiptDate?: Date;
        generateReceipts?: boolean;
        useIndividualDates: boolean;
        state?: ReceiptBatchState;
        receiptBatchEntries?: ReceiptBatchEntry[];
      }
    | undefined;
}): boolean => {
  if (batch === undefined) {
    return false;
  }

  const requiredFieldsPresent =
    (!batch.useIndividualDates ? batch.receiptDate !== undefined : true) &&
    batch.receiptBatchEntries !== undefined &&
    batch.receiptBatchEntries.length > 0 &&
    batch.receiptBatchEntries.every((entry) =>
      isServiceProviderReceiptBatchEntryReadyToSubmit(
        batch.generateReceipts,
        batch.useIndividualDates,
        entry
      )
    );

  const submittableState =
    batch.state === ReceiptBatchState.Draft ||
    batch.state === ReceiptBatchState.ChangeRequested;

  return requiredFieldsPresent && submittableState;
};

// eslint-disable-next-line complexity
export const isServiceProviderReceiptBatchEntryReadyToSubmit = (
  generateReceipts: boolean | undefined,
  useIndividualDates: boolean,
  entry: ReceiptBatchEntry
): boolean => {
  const needsTax = generateReceipts;
  const { lineItems, receiptDate, residentId } = entry;
  const result =
    lineItems !== undefined &&
    lineItems.length > 0 &&
    lineItems.every(
      ({ amountPerItemInCent, name, taxes }) =>
        amountPerItemInCent > 0 &&
        name &&
        (needsTax ? taxes && taxes.length > 0 : true)
    ) &&
    (useIndividualDates ? receiptDate : true);
  return Boolean(residentId !== undefined && result);
};
